<div class="card">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4>{{ "MENU.FUTURE_EMPLOYEE" | translate }}</h4>
    <a *ngIf="futureEmployees.length > 0" routerLink="/dashboard/user/future-employees">{{ "VIEW_ALL" | translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="futureEmployees.length < 1">{{ "NO_FUTURE_EMPLOYEES" | translate }}</div>
    <div *ngFor="let emp of futureEmployees" class="row mb-1">
      <div class="col-12">
        <a *ngIf="emp.type_code === 'candidate'" class="font-weight-medium text-break-line-1 mb-0" target="_blank" routerLink="/dashboard/future-employee/profile/{{ emp.hash }}">{{ emp.complete_name }}</a>
        <a *ngIf="emp.type_code === 'collaborator'" class="font-weight-medium text-break-line-1 mb-0" target="_blank" routerLink="/dashboard/collaborators/edit/{{ emp.hash }}">{{ emp.complete_name }}</a>
        <small>
          {{ "FROM" | translate }} {{ emp.start_date ? _utilsService.formatDate(emp.start_date) : _utilsService.formatDate(emp.transformation_start_date) }} -
          {{ emp.figure_name }}
        </small>
      </div>
    </div>
  </div>
</div>
